import React, { useEffect, useRef } from 'react';
import { ICommentWithVipInfo } from '../../../type';
import { loadAndShowAvatarNickNameplate } from '@src/js/common/ark-extensions/dc-components/avatar-nick-nameplate';
import { VipType } from '@src/js/common/ark-extensions/dc-components/avatar-nick-nameplate/type';
import { getVipTypeFromLevel } from '../../../utils';
import Style from '../index.less';

export interface IAvatarNickNameplateProps {
    commentInfo: Partial<ICommentWithVipInfo>;
    children?: JSX.Element | JSX.Element[];
}

// 头像的位置
export enum AvatarAlignment {
    TOP = 'top', // 头像在昵称和铭牌的上方
    LEFT = 'left', // 头像在昵称和铭牌的左侧，默认为 left
}

const AvatarNickNameplate: React.FC<IAvatarNickNameplateProps> = (props: IAvatarNickNameplateProps) => {
    const avatarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        initTitleComponent();
    });

    const initTitleComponent = async () => {
        if (!avatarRef.current) return;
        const { userImg, nickName, avatarFrameUrl, badgeUrl, vipType, vipLevel } = props.commentInfo;
        const vipTypeFormatted = vipType || getVipTypeFromLevel(vipLevel) || VipType.NONE;
        // 不显示未开通图标
        const nameplateProps = vipTypeFormatted === VipType.NONE ? undefined : {
            vipType: vipTypeFormatted,
            // 上报用
            entry: 'comment',
            nameplateUrl: badgeUrl,
        };
        loadAndShowAvatarNickNameplate({
            container: avatarRef.current,
            avatarProps: {
                src: userImg,
                frame: avatarFrameUrl,
                style: {
                    width: '20px',
                    height: '20px',
                    border: 'none',
                    borderRadius: '4px',
                    marginRight: '10px',
                },
            },
            nickNameProps: {
                nick: nickName,
                maxWidth: vipTypeFormatted === VipType.NONE ? '110px' : '70px',
            },
            avatarAlignment: AvatarAlignment.LEFT,
            nameplateProps,
        });
    };

    return (
        <div className={Style['comment-user-info-wrap']}>
            <div className={Style['comment-user-info']} ref={avatarRef}></div>
            {props.children}
        </div>
    );
};

export default AvatarNickNameplate;
